import { Link } from "react-router";
import { renderBlockContent } from "../kit/blocks";
import { FileCatalogList } from "../kit/files";
import { Heading } from "../kit/Heading";



export default function SectionMultiple({ data, mainColor }) {
  const d = data.sectionMultiple
  const sectionCount = d.contentArray.length
  const contentArray = d.contentArray
  const haveImage = d.contentArray[0].image
  const haveIcon = d.contentArray[0].icon

  let iconDivWidth = "col-span-6"
  let iconClass = ""

  switch (sectionCount) {
    case 2:
      iconDivWidth = "col-span-12 md:col-span-6 flex"
      iconClass = "mt-3 pr-4"

      break;
    case 3:
      iconDivWidth = "col-span-12 md:col-span-4 flex"
      iconClass = "mt-3 pr-4"
      break;
    case 4:
      iconDivWidth = "col-span-12 md:col-span-6 flex"
      iconClass = "mt-3 pr-4"
      break;
  }



  return (
    <>
      <div className="container mx-auto px-5 flex flex-wrap">
        <div className="w-full md:w-1/2">
          {d.heading && <h1>{d.heading.heading ? d.heading.heading : d.heading}</h1>}
          <div>{renderBlockContent(d.text)}</div>
        </div>
        <div className="w-full md:w-1/2">
        </div>
      </div>
      {sectionCount === 2 && haveImage &&
        contentArray.map((ca, i) =>
          <div className="container mx-auto p-4" key={"cad.heading.heading" + i}>
            <div className={"grid grid-cols-12 gap-2"}>
              <div className="col-span-4">
                <img src={ca?.image?.image?.asset?.url} style={{ maxHeight: "400px" }} />
              </div>
              <div className="col-span-8">
                <Heading data={ca.heading} />
                <div>{renderBlockContent(ca.text)}</div>
                <div><FileCatalogList catalogs={ca.files} /></div>
              </div>
            </div>
          </div>
        )
      }

      {sectionCount > 2 && haveImage &&
        contentArray.map((ca, i) => <div key={"ca2d.heading" + i}>
          <div className="container mx-auto p-4">
            <div className={"grid grid-cols-12 gap-2"}>
              {i % 2 === 0 && <div className="col-span-4">
                <img src={ca?.image?.image?.asset?.url} style={{ maxHeight: "400px" }} />
              </div>}
              <div className="col-span-8">
                <Heading data={ca.heading} />
                <div>{renderBlockContent(ca.text)}</div>
                <div><FileCatalogList catalogs={ca.files} /></div>
              </div>
              {i % 2 === 1 && <div className="col-span-4">
                <img src={ca?.image?.image?.asset?.url} style={{ maxHeight: "400px" }} />
              </div>}
            </div>
          </div>
        </div>
        )
      }
      {
        !haveImage &&
        <div>
          <div className="container mx-auto p-4">
            <div className={"grid grid-cols-12 gap-2"}>
              {contentArray.map((ca, i) =>
                <div className={iconDivWidth} key={"caaa" + i}>
                  <img src={ca?.icon?.iconImage?.asset?.url} style={{ height: "32px" }} className={iconClass} />
                  <div>
                    <Heading data={ca.heading} size="small" />
                    <div>{renderBlockContent(ca.text)}</div>
                    {ca.files && <div><FileCatalogList catalogs={ca.files} /></div>}
                    {ca.link && <div><Link to={"/" + ca?.link?.slug?.current} style={{ color: mainColor, fontWeight: 600 }}>Více informací</Link></div>}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div >
      }
    </>
  );


}
